import { render, staticRenderFns } from "./BuscarProducto.vue?vue&type=template&id=3b83ac7c&"
import script from "./BuscarProducto.vue?vue&type=script&lang=js&"
export * from "./BuscarProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports